import { Text } from '@mantine/core';

type StatisticProps = {
  title?: string;
  value?: number;
  suffix?: string;
};

const Statistic = (props: StatisticProps) => {
  const { title = '', value = undefined, suffix = '' } = props;

  return (
    <div className="flex flex-col space-y-1">
      <Text c="gray.5">{title}</Text>

      <Text c="gray.5" size="xl">
        {suffix} {value?.toLocaleString()}
      </Text>
    </div>
  );
};

export default Statistic;
